import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";
import { forwardRef } from "react";
import type { HydratedImage } from "../generated/api/types.gen";

interface GalleryThumbnailCarouselProps {
  images: HydratedImage[];
  currentIndex: number;
  onSelect: (index: number) => void;
  onPrevious: () => void;
  onNext: () => void;
  imageContainerWidth?: number;
}

export const GalleryThumbnailCarousel = forwardRef<
  HTMLDivElement,
  GalleryThumbnailCarouselProps
>(function GalleryThumbnailCarousel(
  { images, currentIndex, onSelect, onPrevious, onNext, imageContainerWidth },
  ref,
) {
  return (
    <div
      className="mt-4 flex items-center justify-center gap-4 w-fit"
      style={
        imageContainerWidth ? { width: `${imageContainerWidth}px` } : undefined
      }
    >
      {/* Left Arrow */}
      <button
        type="button"
        onClick={onPrevious}
        className="flex-shrink-0 w-10 h-10 p-3 bg-[var(--bg-modal)] border border-[var(--bg-modal)] hover:bg-[var(--bg-field)] rounded-lg flex items-center justify-center transition text-[var(--text-primary)]"
      >
        <CaretLeftIcon size={20} />
      </button>

      {/* Thumbnails */}
      <div
        ref={ref}
        className="flex justify-center gap-3 overflow-x-auto scrollbar-hide py-2"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {images.map((img, index) => (
          <button
            type="button"
            key={img.id}
            data-thumbnail
            onClick={() => onSelect(index)}
            className={`flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden transition-all border-2 ${
              index === currentIndex
                ? "border-[var(--accent-primary)]"
                : "border-[var(--stroke-field)] opacity-60 hover:opacity-100"
            }`}
          >
            <img
              src={img.url}
              alt={`Iteration ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>

      {/* Right Arrow */}
      <button
        type="button"
        onClick={onNext}
        className="flex-shrink-0 w-10 h-10 p-3 bg-[var(--bg-modal)] border border-[var(--bg-modal)] hover:bg-[var(--bg-field)] rounded-lg flex items-center justify-center transition text-[var(--text-primary)]"
      >
        <CaretRightIcon size={20} />
      </button>
    </div>
  );
});
